import React, { useEffect, useState } from "react";
import "./Page.css";
import { useDispatch, useSelector } from "react-redux";
import { getAllGallery } from "../../../actions/all_gallery.action";
import { useNavigate } from "react-router";
import { Translate } from "../../Translate/Translate";
import { Link } from "react-router-dom";
import VideoPopup from "../../../Components/video-gallery/index";
import i18next from "i18next";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Preloader from "../../Preloader";
import { API_URI } from "../../../axios";
import PageHeader from "../../page-header/PageHeader";

const GalleryPage = () => {
  const navigate = useNavigate();
  const language = i18next.language;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllGallery(language));
  }, [language]);

  const gallery = useSelector((state) => state.allgallery);

  const { allgallery_ } = gallery;

  const { results } = allgallery_;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{`${t("gallery")} - ${t(
          "Ashgabat_International_Airport"
        )}`}</title>
      </Helmet>
      {results ? (
        <div className="gallery-page">
          <PageHeader
            title={t("gallery")}
            breadCrumbItems={[
              { label: t("home"), path: "/" },
              { label: t("gallery"), path: "#" },
            ]}
          />
          <div className="container py-12">
            {/* <div className="section-title text-center">
                            <h1 className="fw-bold"><Translate title='pictures' /></h1>
                        </div> */}
            <div className="image-gallery grid-wrapper grid-lg-3 grid-md-2 grid-sm-2 grid-xs-1">
              {results.map((item, index) =>
                item.type === "image" ? (
                  <div
                    className={`case-study gallery-item case-study-style-01`}
                  >
                    <div className="w-full h-full gallery-image relative">
                      <img
                        className="img-fluid object-contain w-full h-full"
                        key={item.id}
                        src={
                          item.type === "image"
                            ? `${API_URI}${item.data.cover_image}`
                            : item?.data?.videos.length
                            ? `${API_URI}${item.data.videos[0].thumb}`
                            : ""
                        }
                        alt={item.title}
                        // cat={img.category}
                        //alt={`Image ${index}`}
                        // onClick={() => openLightbox(index)}
                      />
                    </div>
                    <div className="case-study-info">
                      <Link
                        className="case-study-title"
                        to={{ pathname: `/gallery/${item.data.id}` }}
                      >
                        {item.data.title}
                      </Link>
                      {/* <Link
                                                className="icon-btn"
                                                to={{ pathname: `/gallery-details/${item.data.id}` }}
                                            >
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </Link> */}
                    </div>
                  </div>
                ) : (
                  <VideoPopup
                    key={index}
                    index={index}
                    title={item.data.title}
                    videoURL={`${API_URI}${item.data.videos[0].src}`}
                    videoImage={`${API_URI}${item.data.videos[0].src}`}
                  />
                )
              )}
            </div>
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default GalleryPage;
